export interface INaturalTextSpecifiable {
  isNaturalViewEnable: boolean;
  naturalText: string;
  currentNaturalText: string;
}

export function instanceOfINaturalTextSpecifiable(instance: any): instance is INaturalTextSpecifiable {
  return instance && instance.isNaturalViewEnable !== undefined;
}
